var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('SearchResultFacets'),_c('SearchResultsContainer',{class:['results-container', _vm.isSpecialSearch ? 'results-container-expanded' : '']})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }